import { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert, AlertColor } from "@mui/material";

import { notificationActionDispatch } from "../../store/notification/actions";
import { useAppDispatch } from "../../hooks";

type NotificationProps = {
  notification: {
    message: string;
    type: string;
    messageId: number;
  };
};

const Notification = (props: NotificationProps) => {
  const {
    notification: { message, type, messageId },
  } = props;
  const [notiOpen, setNotiOpen] = useState(true);

  const { setNotification } = notificationActionDispatch(useAppDispatch());

  if (!message) {
    return null;
  }

  const closeNotification = () => {
    setNotiOpen(false);
    setNotification({ message: "", type: "", messageId: 0 });
  };

  return (
    <Snackbar
      key={messageId}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={notiOpen}
      autoHideDuration={3000}
      onClose={closeNotification}
      className="w-[250px]"
    >
      <Alert severity={type as AlertColor} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
export default Notification;
